import Axios from '../../../networking/interceptor';
import { driver_authorization_letter } from '../../../networking/urlEndPoints';

/**
 * GET driver authorization letter for the current pharmacy.
 * @param {number|string} pharmacyId
 * @returns {Promise<{ success: boolean, data: object, message: string }>}
 */
export const fetchAuthorizationLetter = async (pharmacyId) => {
	const response = await Axios.get(driver_authorization_letter, {
		params: { pharmacy_id: pharmacyId },
	});
	return response.data;
};
